import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { PromoCode } from 'app/shared/models/class/discount/discount';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { DiscountService } from 'app/shared/services/discount/discount.service';
import * as moment from 'moment';

export interface DialogData {
  action: string;
  discount: any;
  clubCode: string;
}

type switchOptions = {
  [key: string]: any
};


@Component({
  selector: 'app-open-dialog-add-edit-discount',
  templateUrl: './open-dialog-add-edit-discount.component.html',
  styleUrls: ['./open-dialog-add-edit-discount.component.scss']
})
export class OpenDialogAddEditDiscountComponent implements OnInit {

  addDiscountForm: UntypedFormGroup;
  title: string;
  confirm = false;

  typeOfDiscount = false;
  color: ThemePalette = 'primary';
  clubs: ClubDetails[];
  userConnected: InfosUser;
  clubCode: ClubDetails;

  today = new Date();
  btnConfirm: string;
  text: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpenDialogAddEditDiscountComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private clubService: ClubService,
    private authService: AuthService,
    private discountService: DiscountService

  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
    this.getClubs();
  }

  onSubmit(): void {

    const startHour = this.f.promoStartTime.value.split(':');
    const endHour = this.f.promoEndTime.value.split(':');

    const startDate = new Date(this.f.promoStartDate.value);
    startDate.setHours(startHour[0]);
    startDate.setMinutes(startHour[1]);

    const endDate = new Date(this.f.promoEndDate.value);
    endDate.setHours(endHour[0]);
    endDate.setMinutes(endHour[1]);


    const discount = new PromoCode(this.f.promoCodeName.value, this.f.clubCode.value.clubCode, this.f.withPercentage.value ? 0 : this.f.promoAmount.value, this.f.withPercentage.value ? this.f.promoPercentage.value : 0, startDate, endDate);

    switch (this.data.action) {
      case 'add':
        this.discountService.addPromoCodeAdmin(discount).subscribe({
          next: () => { this.dialogRef.close({ data: this.f.clubCode.value.clubCode }); }
        });
        break;

      case 'edit':
        discount.promoCodeKey = this.data.discount.promoCodeKey;
        this.discountService.updatePromoCode(discount).subscribe({
          next: () => { this.dialogRef.close({ data: this.f.clubCode.value.clubCode }); }
        });
        break;

      default:
        break;
    }

  }

  changeType(): void {
    this.typeOfDiscount = !this.typeOfDiscount;
    this.typeOfDiscount ?
      this.f.percentage.reset() :
      this.f.amount.reset();
  }

  getDateLimit(date: string): string | object {

    const dateCheck = {
      add: {
        start: this.today,
        end: this.f.promoStartDate.value ? this.f.promoStartDate.value : this.today
      },
      edit: {
        start: this.f.promoStartDate.value ? this.f.promoStartDate.value : this.today,
        end: this.f.promoStartDate.value ? this.f.promoStartDate.value : this.today,
      }
    };

    return dateCheck[this.data.action][date];
  }

  closeDialog(): void {
    this.dialogRef.close({ data: this.data.discount?.clubCode });
  }

  private getLabel(type: string): string {
    const label: switchOptions = {
      add: {
        title: 'Ajouter une réduction',
        confirm: 'Ajouter',
        text: 'Réduction ajoutée'
      },
      edit: {
        title: 'Éditer une réduction',
        confirm: 'Mettre à jour',
        text: 'Réduction mise à jour',
      },
    };
    return label[this.data.action][type];
  }


  private getClubs(): void {
    this.clubService.getClubDetails().subscribe({
      next: clubs => {
        this.clubs = clubs?.sort((a, b) => a.clubCode.localeCompare(b.clubCode));
        if (this.userConnected.role === 'AdminMSR') {
          this.clubCode = clubs.find(club => club.clubCode === this.userConnected.club_code);
          this.f.clubCode.setValue(this.clubCode);
          this.f.clubCode.disable();
        }

        if (this.userConnected.role === 'admin' && this.data.clubCode) {
          this.clubCode = clubs.find(club => club.clubCode === this.data.clubCode);
          this.f.clubCode.setValue(this.clubCode);
          this.f.clubCode.disable();
        }
      }
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.title = this.getLabel('title');
    this.btnConfirm = this.getLabel('confirm');
    this.text = this.getLabel('text');
  }

  get f() {
    return this.addDiscountForm.controls;
  }

  // const startMoment: moment.Moment = moment(new Date());
  //   const startTime: string = moment(startMoment).add(5, 'minutes').format('HH:mm');

  private initForm(): void {
    const promoStartDate = (this.data.discount?.promoStartDate ? new Date(this.data?.discount.promoStartDate) : new Date()).toISOString();
    const promoStartTime = moment(promoStartDate).format('HH:mm');
    const promoEndDate = (this.data.discount?.promoEndDate ? new Date(this.data?.discount.promoEndDate) : new Date()).toISOString();
    const promoEndTime = moment(promoEndDate).format('HH:mm');

    let withPercentage = false;
    if (this.data.discount) {
      withPercentage = this.data.discount.promoPercentage ? true : false;
    }

    this.addDiscountForm = this.formBuilder.group({
      promoCodeName: [this.data.discount ? this.data.discount.promoCodeName : ''],
      promoAmount: [this.data.discount ? this.data.discount.promoAmount : null],
      promoPercentage: [this.data.discount ? this.data.discount.promoPercentage : null],
      withPercentage: [withPercentage],
      clubCode: [''],
      promoStartDate: [this.data.discount ? this.data.discount.promoStartDate : ''],
      promoStartTime: [this.data.discount ? promoStartTime : '00:00'],
      promoEndDate: [this.data.discount ? this.data.discount.promoEndDate : ''],
      promoEndTime: [this.data.discount ? promoEndTime : '23:59'],
    });

  }


}
